<template>
  <div>
    <van-nav-bar
      title=""
      left-text=""
      left-arrow
      @click-left="onClickLeft"
      v-show="!noBarArr.includes(routeName)"
    />
    <div v-if="getToken() || $route.name === 'binding'">
      <keep-alive>
        <router-view
          class="h5-view"
          v-if="$route.meta.keepAlive && !$route.meta.ifIframe"
        />
      </keep-alive>
      <router-view
        class="h5-view"
        v-if="!$route.meta.keepAlive && !$route.meta.ifIframe"
      />
    </div>
    <div v-else class="unbind">
      您尚未绑定
      <div class="unbind-btn" @click="unbind">去绑定</div>
    </div>
    <!-- v-show="noBarArr.includes(routeName)" -->
    <footer-box :list="footerList" v-show="!$route.meta.noBar" />
  </div>
</template>
<script>
import { getToken } from '@/utils/auth.js';
import footerBox from '@/components/footer';
export default {
  components: { footerBox },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.beforeRouteEnterFrom = from;
    });
  },
  data() {
    return {
      footerList: [
        {
          name: '收费项目',
          urlNmae: 'homeIndex',
          img: 'index',
        },
        {
          name: '购物车',
          urlNmae: 'shoppingCartIndex',
          img: 'shopping-cart',
        },
        {
          name: '个人中心',
          urlNmae: 'userIndex',
          img: 'user',
        },
      ],
      beforeRouteEnterFrom: {},
    };
  },
  computed: {
    noBarArr() {
      return this.footerList.map((i) => i.urlNmae);
    },
    routeName() {
      return this.$route.name;
    },
  },
  methods: {
    getToken,
    unbind() {
      this.$router.push({ name: 'binding' });
    },
    onClickLeft() {
      if (
        !this.beforeRouteEnterFrom.name ||
        this.$route.query.secondaryRollback
      ) {
        this.$router.push({ name: 'homeIndex' });
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.h5-view {
  // padding-bottom: 55px;
  box-sizing: border-box;
  background: #ebebeb;
  height: calc(100vh - 80px);
  overflow-y: auto;

}
.unbind {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  .unbind-btn {
    padding: 5px 10px;
    color: #fff;
    font-size: 17px;
    background: #07c160;
  }
}

.van-nav-bar {
  background: #000;
  ::v-deep {
    .van-nav-bar__content {
      height: 40px !important;
    }
    .van-icon {
      color: #fff;
      font-size: 18px;
    }
  }
}
</style>
